import { start } from '@jutro/app';
import { initDefaultGA } from '@jutro/events';
import  { BrandingService } from '@xengage/gw-portals-branding-js'
import { LocaleService, G11nstore } from 'gw-portals-i18n-react';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

import 'regenerator-runtime';

import { LoaderExt } from 'gw-components-platform-react';
import App from './app/App';
import { initDatadogRum } from './util/datadogRum';

import { configureLegacyComponentMap } from '@jutro/legacy/uiconfig';
configureLegacyComponentMap();

// GCD-2642: the login-app reads appNameCookie cross-subdomain to route users to the
// correct portal login page. Set it from the customer layer (not the GW platform
// AuthProvider) so Guidewire upgrades can no longer overwrite it.
const setPortalAppCookie = (appName) => {
    const { hostname } = window.location;
    const index = hostname.indexOf('.');
    const domain = hostname === 'localhost' || index <= 0 ? hostname : hostname.slice(index + 1);
    document.cookie = `appNameCookie=${appName}; domain=${domain}; path=/`;
};

setPortalAppCookie('CE');

const { trackingConfig = {}, authentication = {}, datadogConfig = {} } = appConfig;

const gaTrackingId = trackingConfig.GA_TRACKING_ID;

if (gaTrackingId) {
    initDefaultGA(trackingConfig);
}

initDatadogRum(datadogConfig);

const config = {
    ...authentication.servers.okta,
    ...appConfig.credentials
}


start(App, {
    rootId: 'root',
    themeConfig: BrandingService.getBrandingTheme(),
    messageLoader: LocaleService.loadMessages,
    coreMessageLoader: LocaleService.loadCoreMessages,
    config: [config],
    refreshOnLocaleChange: true,

    // routerBasename: '/account-management',
    onInit: () => {
        LocaleService.register();
    },

    g11nStore: G11nstore(),

    appName: {
        id: 'digital.appName',
        defaultMessage: 'CustomerEngage Account Management'
    },

    appDescription: 'CustomerEngage Account Management',
    LoadingComponent:LoaderExt,
});